import { render } from "./DesktopHeader.vue?vue&type=template&id=1391f2bd"
import script from "./DesktopHeader.vue?vue&type=script&lang=js"
export * from "./DesktopHeader.vue?vue&type=script&lang=js"

import "./DesktopHeader.vue?vue&type=style&index=0&id=1391f2bd&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__